!function () {
  "use strict";

  const MOBILE_QUERY = "(max-width: 749px)";

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function initTextReveal(root) {
    const text = root.querySelector("[data-centered-dual-images-text]");
    if (!text) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            text.classList.add("is-visible");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(text);
  }

  function resetParallax(root) {
    root.querySelectorAll("[data-centered-dual-images-parallax-target]").forEach((target) => {
      target.style.transform = "";
    });
  }

  function initParallax(root) {
    destroyParallax(root);
    resetParallax(root);

    if (isMobile()) return;

    const frames = Array.from(root.querySelectorAll("[data-centered-dual-images-parallax]"));
    if (!frames.length) return;

    const amount = parseInt(root.dataset.parallaxAmount, 10) || 60;

    const onScroll = () => {
      frames.forEach((frame) => {
        const parallax = frame.querySelector("[data-centered-dual-images-parallax-target]");
        if (!parallax) return;

        const rect = frame.getBoundingClientRect();
        const progress = -rect.top / window.innerHeight;
        parallax.style.transform = `translateY(${progress * amount}px)`;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    root._centeredDualImagesScroll = onScroll;
  }

  function destroyParallax(root) {
    if (root._centeredDualImagesScroll) {
      window.removeEventListener("scroll", root._centeredDualImagesScroll);
      root._centeredDualImagesScroll = null;
    }
  }

  function initSection(root) {
    initTextReveal(root);
    initParallax(root);
  }

  function initAll(scope = document) {
    scope.querySelectorAll(".centered-dual-images").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target) initAll(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    if (event.target) {
      event.target.querySelectorAll(".centered-dual-images").forEach(destroyParallax);
    }
  });

  window.matchMedia(MOBILE_QUERY).addEventListener("change", () => {
    initAll();
  });
}();
